module.exports = "/packs/sns-icon-twitter-c2bb286abd970fa6ebd7ec4778acb592.png";